<card name="User stores table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="id" let-item>
        <td>
          {{ item.id }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="store" let-item>
        <td>
          {{ item.store.name }} <br>
          <small class="text-muted">{{ item.store.id }}</small>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="updatedAt" let-item>
        <td>
          {{ item.updatedAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="actions">
        <td class="text-right text-nowrap">
          <div class="d-flex mx-n1">
            <button class="btn btn-secondary mx-1">Add purchase</button>
            <button class="btn btn-primary mx-1">Add bonus</button>
          </div>
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
